<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12" md="12">
        <div class="box mt-8">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <a
                href="https://viasm.edu.vn/"
                target="_blank"
                v-bind="attrs"
                v-on="on"
                style="display: block; width: fit-content; margin: 0"
              >
                <div class="link linkvt d-flex logovt">
                  <img src="../assets/logovt.png" alt="" />
                </div>
              </a>
            </template>
            <h3 class="toollip">VIASM - Viện nghiên cứu cao cấp về toán</h3>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <a
                href="http://hus.vnu.edu.vn/"
                target="_blank"
                v-bind="attrs"
                v-on="on"
                style="display: block; width: fit-content; margin: 2rem"
              >
                <div class="link linkvt d-flex">
                  <img src="../assets/logohus.png" alt="" />
                </div>
              </a>
            </template>
            <h3 class="toollip">Trường Đại học Khoa học Tự nhiên, ĐHQGHN</h3>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <a
                href="https://www.facebook.com/groups/VietnamQuantumComputing"
                target="_blank"
                v-bind="attrs"
                v-on="on"
                style="
                  display: block;
                  width: fit-content;
                  margin: 2rem;
                  margin-top: 4rem;
                "
              >
                <div class="link linkvt d-flex align-center">
                  <img src="../assets/logofacebook.png" alt="" />
                  <h2 class="ml-3">Vietnam <br />Quantum <br />Computing</h2>
                </div>
              </a>
            </template>
            <h3 class="toollip">Quantum Computing Community in Vietnam</h3>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.box {
  .linkvt {
    height: 10rem;
    img {
      display: block;
      height: 100%;
    }
    @media (max-width: 500px) {
      height: 3rem;
    }
  }
  @media (max-width: 500px) {
    .logovt {
      margin-left: 1.5rem !important;
    }
  }
  h2 {
    color: rgb(7, 7, 145);
    font-size: 2.3rem;
    font-weight: bold;
    line-height: 2.8rem;
    @media (max-width: 500px) {
      font-size: 1rem;
      line-height: 1.3rem;
    }
  }
  .toollip {
    background: greenyellow !important;
    padding: 2rem;
  }
}
.box {
  background: white;
  padding: 2rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px;
  @media (max-width: 460px) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>